/**
 * Widget row presets — used when adding a widget row in custom dashboard ("Add widget").
 */

export const KPI_COUNT_OPTIONS = [2, 3, 4];

const KPI_COLS = (count = 4) => {
  const safeCount = KPI_COUNT_OPTIONS.includes(count) ? count : 4;
  const colClass = safeCount === 2 ? 'col-6' : safeCount === 3 ? 'col-4' : 'col-3';
  return Array.from({ length: safeCount }, (_, index) => ({
    id: `kpi_${index}`,
    col: colClass,
    slotKey: `kpi_${index}`,
    slotType: 'kpi',
    slotIndex: index,
  }));
};

export const WIDGET_PRESETS = [
  {
    id: 'dashboard_kpi',
    name: 'KPI cards',
    description: 'Row of metric cards.',
    icon: 'fa-th-large',
    previewVariant: 'kpi',
    rows: [
      {
        id: 'kpi_row',
        rowType: 'kpi',
        layout: 'kpi-grid',
        cols: KPI_COLS(4),
      },
    ],
  },
  {
    id: 'dashboard_single_chart',
    name: 'Single chart',
    description: 'One full-width trend or distribution graph.',
    icon: 'fa-chart-area',
    previewVariant: 'single_chart',
    rows: [
      {
        id: 'chart_row',
        rowType: 'chart',
        cols: [
          {
            id: 'chart_main',
            col: 'col-12',
            slotKey: 'chart_main',
            slotType: 'chart',
            variant: 'tall',
          },
        ],
      },
    ],
  },
  {
    id: 'dashboard_two_column',
    name: 'Two columns',
    description: 'Side-by-side panels — chart or table in each column.',
    icon: 'fa-columns',
    previewVariant: 'two_column',
    rows: [
      {
        id: 'two_col_row',
        rowType: 'mixed',
        layout: 'chart-grid',
        cols: [
          {
            id: 'column_left',
            col: 'col-6',
            slotKey: 'column_left',
            slotType: 'panel',
            allowedTypes: ['chart', 'table'],
          },
          {
            id: 'column_right',
            col: 'col-6',
            slotKey: 'column_right',
            slotType: 'panel',
            allowedTypes: ['chart', 'table'],
          },
        ],
      },
    ],
  },
  {
    id: 'dashboard_single_table',
    name: 'Single table',
    description: 'Full-width dynamic reports table.',
    icon: 'fa-table',
    previewVariant: 'single_table',
    rows: [
      {
        id: 'table_row',
        rowType: 'table',
        cols: [
          {
            id: 'dynamic_reports',
            col: 'col-12',
            slotKey: 'dynamic_reports',
            slotType: 'table',
          },
        ],
      },
    ],
  },
];

export const DEFAULT_WIDGET_PRESET_ID = 'dashboard_kpi';

export const getWidgetPresetById = (id) =>
  WIDGET_PRESETS.find((preset) => preset.id === id) || null;

export { KPI_COLS };
